import { $Q } from "graditify-utils"
import { toggleDataActive } from "../utils/toggle-dataset"
// import moment from "moment"

export class InstafeedItem extends HTMLElement {
  constructor(data) {
    super()
    this.data = data
  }

  connectedCallback() {
    this.fillNodes()
    this.openModal()
  }

  /**
   * Render items
   */
  fillNodes() {
    this.innerHTML = this.itemComponent()
  }

  /**
   * Set toggleDataActive
   * @returns null - stop called
   */
  openModal() {
    const modalContainer = $Q('#js-insta-modal')
    if (!modalContainer) return

    toggleDataActive(this, '#js-insta-modal', {
      overlay: true,
      cb: this.modalComponent.bind(this, modalContainer),
      blockScroll: true
    })
  }

  /**
   * Create item instafedd structure
   * @returns {string} HTML string
   */
  itemComponent = () => {
    const {
      username,
      thumbnail_url,
      media_url,
      index
    } = this.data
    const img = thumbnail_url || media_url

    return `
      <div>
        <img
          loading="lazy"
          class="lazyload instafeed__image"
          src="${img}"
          alt="Media instagram ${index + 1} of ${username}"
          width="100"
          height="100"
        />
      </div>
    `
  }

  /**
   * Create modal instafedd structure
   * @param {node} parentModal - Modal container
   */
  modalComponent = (parentModal) => {
    const {
      username,
      permalink,
      thumbnail_url,
      media_url,
      timestamp,
      caption,
      logoSrc,
      logoAlt,
      index
    } = this.data
    const img = thumbnail_url || media_url
    const modalContent = $Q('.js-insta-modal-content', parentModal)

    modalContent.innerHTML = `
      <div class="instafeed__modal-content">
        <img
          loading="lazy"
          class="lazyload instafeed__modal-image"
          src="${img}"
          alt="Media instagram ${index + 1} of ${username}"
        />

        <div class="instafeed__modal-caption">
          ${logoSrc
            ? `<a href="${permalink}"><img class="logo" src="${logoSrc}" alt="${logoAlt}"/></a>`
            : ''
          }
          <span class="instafeed__modal-caption-date">
            ${this.dateFormat(timestamp)}
          </span>

          <div class="instafeed__modal-caption-text">
            ${caption}
          </div>
        </div>
      </div>
    `
  }

  dateFormat = (timestamp) => {
    const postDate = moment(new Date(timestamp))
    const currentDate = moment(new Date())
    const daysDiff =  currentDate.diff(postDate, 'days') + 1
    const monthsDiff =  currentDate.diff(postDate, 'months')
    const {
      days,
      day,
      months,
      month
    } = window.dates_messages

    if (monthsDiff === 1) {
      return `${month}`
    } else if (monthsDiff > 1) {
      return `${monthsDiff} ${months}`
    } else if (daysDiff === 0 || daysDiff === 1) {
      return `${day}`
    } else if (daysDiff > 1) {
      return `${daysDiff} ${days}`
    }
  }

}

window.customElements.define('insta-feed-item', InstafeedItem)
